/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pos_Display_Cart_Sync_FailedInputs */

const vi_pos_display_cart_sync_failed = /** @type {(inputs: Pos_Display_Cart_Sync_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giỏ hàng chưa đồng bộ được sang màn hình khách.`)
};

/**

* @param {Pos_Display_Cart_Sync_FailedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pos_display_cart_sync_failed = /** @type {((inputs?: Pos_Display_Cart_Sync_FailedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pos_Display_Cart_Sync_FailedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pos_display_cart_sync_failed(inputs)
});